export default class {

  constructor() {
    this.time = new Date();
  }

  log(m) {
    console.log(this.message(m));
  }

  message(m) {
    const t = new Date();
    let message = `[${t - this.time}ms] ${m}`;
    this.time = t;
    return message;
  }

}
